'use client';
import React__default, { useEffect } from 'react';
import { useNonNullishContext } from '../../../hooks/use-non-nullish-context.js';

/**
 * This context/provider is to lift the react-aria <Item> state up the react tree for combobox and listbox components
 *
 * For internal use only.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const SwanCollectionContext = /*#__PURE__*/ React__default.createContext(undefined);
function useCollectionContext() {
    return useNonNullishContext(SwanCollectionContext);
}
/**
 * Updates the item's disabled state in the collection context
 */ function useTrackDisabledState(key, disabled) {
    const { setDisabledKeys } = useCollectionContext();
    useEffect(()=>{
        if (disabled != null) {
            setDisabledKeys((s)=>{
                const newState = new Set(s);
                if (disabled) {
                    newState.add(key);
                } else {
                    newState.delete(key);
                }
                return newState;
            });
        }
    }, [
        setDisabledKeys,
        key,
        disabled
    ]);
}

export { SwanCollectionContext, useCollectionContext, useTrackDisabledState };
